import { formatInTimeZone } from "date-fns-tz";
import { es } from "date-fns/locale";

export const formatDateTimeEsCO = (date) => {
  return formatInTimeZone(
    date,
    "America/Bogota",
    "dd 'de' MMMM 'de' yyyy h:mm aaaa",
    { locale: es }
  );
};
